<template>
    <b-modal
        id="ModalUpdateSelection"
        title="Modifier une sélection"
        size="lg"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        scrollable
    >
        <FormSelection
            ref="formSelectionUpdate"
            :sit="sit"
            :project="project"
            :selection="selection"
        />
        <template #modal-footer="{ cancel }">
            <b-button
                variant="outline-danger"
                @click="$bvModal.show('UpdateSelection.delete')"
            >
                Supprimer la sélection
            </b-button>
            <div class="flex-grow-1" />
            <b-button variant="outline-secondary" @click="cancel()">
                Annuler
            </b-button>
            <b-button variant="kalkin-2" @click="save">
                Enregistrer et quitter
            </b-button>
        </template>

        <ModalDanger
            uid="UpdateSelection.delete"
            @confirmed="onDeleteConfirmed"
            message="Voulez vous vraiment supprimer cette sélection?"
            details="Aucune fiche ne sera supprimée, seulement les associations avec celles-ci"
        />
    </b-modal>
</template>
<script>
import FormSelection from "./FormSelection";
import ModalDanger from "@/components/modal/ModalDanger";
export default {
    components: {
        FormSelection,
        ModalDanger,
    },

    props: {
        sit: { type: String, required: true },
        project: { type: Object, required: true },
        selection: { type: Object, required: false },
    },

    methods: {
        async save() {
            if (await this.$refs.formSelectionUpdate.save()) {
                this.$bvModal.hide("ModalUpdateSelection");
                this.$emit("saved");
            }
        },

        async onDeleteConfirmed() {
            await this.$store.dispatch("kbsit/deleteSelection", {
                sit: this.sit,
                projectId: this.project.id,
                selectionId: this.selection.id,
            });
            this.$bvModal.hide("ModalUpdateSelection");
            this.$emit("saved");
        },
    },
};
</script>
